import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { RegexFields } from '../../../constants/utils/regexFields';
import { resetPassword, resetAuth } from '../../../actions/auth-api';
import { useDispatch, useSelector } from 'react-redux';
import parsePhoneNumber from 'libphonenumber-js';
import * as R from 'ramda';

export const PasswordRecover = () => {
	const usernameForm = useRef(null);
	const history = useHistory();
	const location = useLocation();
	const dispatch = useDispatch();
	const auth = useSelector(state => state.auth);


	//if loggedin logout
	const [isLoading, setIsLoading] = useState(false);
	const [username, setUsername] = useState('');

	useEffect(() => {
		if (!R.isNil(localStorage.getItem("access_token"))) {
			localStorage.removeItem("access_token");
		}
		dispatch(resetAuth());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function formSubmit(event) {
		event.preventDefault();
		const emailRegex = new RegExp(RegexFields.email);
		const mobileRegex = new RegExp(RegexFields.frenchPhoneNumber);

		if (mobileRegex.test(username)) {
			const phoneNumber = parsePhoneNumber(username, 'FR');
			if (R.isNil(phoneNumber)) {
				document.getElementById("username").setCustomValidity("Numéro de télephone invalide.");
			}
		}


		if (usernameForm.current.checkValidity()) {
			setIsLoading(true);
			if (emailRegex.test(username)) {
				dispatch(resetPassword(username, null))
					.then(() => setIsLoading(false))
					.catch(() => setIsLoading(false))

			}
			else if (mobileRegex.test(username)) {
				const phoneNumber = parsePhoneNumber(username, 'FR');
				if (!R.isNil(phoneNumber)) {
					dispatch(resetPassword(null, phoneNumber.formatInternational().replace(/\s/g, '').trim()))
						.then(() => setIsLoading(false));
				}

			}
		}
		usernameForm.current.classList.add('was-validated');
	}

	return (
		<div className="col order-first order-lg-last h-inherit scroll-default">
			<nav className="nav text-right mb-auto">
				<h1 className="sr-only visually-hidden">Help</h1>
				<span className="small font-weight-bold">Besoin d'aide ? <a className="text-info" href="mailto:contact@assistarobase.fr">Nous contacter</a></span>
			</nav>
			<form className="container-xl-base py-2 mb-auto" noValidate ref={usernameForm} onSubmit={(event) => { formSubmit(event); }}>
				<h1 className="h1 text-primary font-weight-bolder mb-6">Récupérez votre mot de passe</h1>
				<div className="form-group">
					<label className="h6 font-weight-bolder" htmlFor="email">Saisissez votre Email ou Numéro de portable</label>
					<input type="text" required className="form-control" id="username" defaultValue={username} placeholder="Email ou Numéro de portable" pattern={RegexFields.email + '|' + RegexFields.frenchPhoneNumber} onInput={(event) => {
						event.preventDefault();
						document.getElementById("username").setCustomValidity("");
						if (!R.isNil(auth.resetByEmail)) {
							dispatch(resetAuth());
						}
						setUsername(event.target.value);
						// setDisplayError(undefined);
					}} onBlur={() => {
						setUsername(username.replace(/\s/g, '').trim());;
					}} />
					<div className="invalid-feedback">Email ou numéro de portable invalide.</div>
					{auth.resetByEmail === true ? <div className='alert-info alert d-block mt-2'>Un e-mail contenant un lien de réinitialisation de mot de passe a été envoyé à l'adresse e-mail de l'utilisateur.</div> : ''}

				</div>
			</form>
			<footer className="block mt-auto text-left w-100 rounded-inherit">
				<Link to={`/auth/signin${location.search}`} className="btn btn-faded px-md-gutter mr-3">Retour</Link>
				<button className={"btn btn-primary px-md-gutter px-4 loading-btn" + (isLoading ? ' show' : '')} disabled={isLoading}
					onClick={(event) => { formSubmit(event); }}>Récupérer
					<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
				</button>



			</footer>
		</div>
	);
};